import type { IDomain } from "@bprotsyk/aso-core";

const PDL_APPLICATION_TARGET = "main";

export const isPdlApplicationDomain = (domain: IDomain): boolean => {
  if (!domain?.name) return false;

  const registrar = String((domain as any).registrar || "").toLowerCase();
  const purchasedThroughNamecheap = registrar === "namecheap" || Boolean((domain as any).namecheapId);

  return String(domain.target).toLowerCase() === PDL_APPLICATION_TARGET && purchasedThroughNamecheap;
};
